/**
 * Mapeo de idTipoMedioDePago (ERP) a códigos AFIP FormaPago (UN/CEFACT).
 * Usado para la "Condición de venta" en facturas electrónicas.
 *
 * Códigos AFIP según UN/CEFACT:
 * 10=Efectivo, 20=Cheque, 30=Transferencia Crédito, 45=Transferencia Crédito Bancario,
 * 48=Tarjeta Crédito, 49=Tarjeta Débito, etc.
 */
const TIPO_MEDIO_A_AFIP = {
    1: { codigoAfip: 10, label: "Efectivo" }, // Efectivo
    2: { codigoAfip: 49, label: "Tarjeta de débito" }, // Débito
    3: { codigoAfip: 48, label: "Tarjeta de crédito" }, // Tarjeta crédito
    4: { codigoAfip: 45, label: "Transferencia" }, // Otros electrónicos (Modo, MP, etc.)
    5: { codigoAfip: 30, label: "Cuenta Corriente" }, // Cuenta Corriente (Transferencia Crédito)
    8: { codigoAfip: 20, label: "Cheque" }, // Cheque
    9: { codigoAfip: 45, label: "Transferencia" }, // Mis Pagos MP
  }
  
  /**
   * Obtiene el código AFIP y label para "Condición de venta" según el tipo de medio de pago.
   * @param {number} idTipoMedioDePago - ID del TipoMedioDePago en el ERP
   * @param {string} [descripcionMedio] - Descripción del medio (opcional, para fallback)
   * @returns {{ codigoAfip: number, label: string } | null}
   */
  export function getFormaPagoAfip(idTipoMedioDePago, descripcionMedio = "") {
    if (idTipoMedioDePago == null || idTipoMedioDePago === undefined) {
      return null
    }
    const mapped = TIPO_MEDIO_A_AFIP[Number(idTipoMedioDePago)]
    if (mapped) {
      return mapped
    }
    // Fallback: usar descripción si no hay mapeo (para tipos custom)
    if (descripcionMedio && typeof descripcionMedio === "string") {
      return {
        codigoAfip: 10, // Efectivo por defecto
        label: descripcionMedio.trim() || "CONTADO",
      }
    }
    return { codigoAfip: 10, label: "CONTADO" }
  }
  